import type { ColorPickerProps } from '@workramp/ui';
import { IconButton, InputGroup } from '@workramp/ui';
import { ColorPickerSetting } from '../ColorPickerSetting';

interface ColorPickerWithDefaultSettingProps extends ColorPickerProps {
  isLocked: boolean;
  onLockPress: () => void;
}

export const ColorPickerWithDefaultSetting = ({
  label,
  value,
  isLocked,
  onChange,
  onLockPress,
  ...props
}: ColorPickerWithDefaultSettingProps) => {
  const iconName = isLocked ? 'lock-lock:regular' : 'lock-unlock:regular';
  const iconLabel = isLocked ? 'Override Default' : 'Sync to Default';

  return (
    <InputGroup label={label}>
      <ColorPickerSetting
        hideLabel
        label={`${label} color picker`}
        allowAlpha
        value={value}
        onChange={onChange}
        {...props}
        isDisabled={isLocked}
      />
      <IconButton iconName={iconName} label={iconLabel} color="secondary" variant="outline" onPress={onLockPress} />
    </InputGroup>
  );
};
